(function(root){
'use strict';
const PAGE_WIDTH_MM=297, PAGE_HEIGHT_MM=210;
// Mockup allowance only. Confirm cutting gap and printer margins before production.
const CUT_GAP_MM=5;
function layoutPair(photos,start=0){
 const pair=[photos[start]||null,photos[start+1]||null];
 const naturalHeights=pair.map(p=>p?PAGE_WIDTH_MM*p.image.naturalHeight/p.image.naturalWidth:PAGE_WIDTH_MM/3);
 const height=(PAGE_HEIGHT_MM-CUT_GAP_MM)/2;
 const slots=naturalHeights.map((naturalHeight,i)=>({index:start+i,x:0,y:i*(height+CUT_GAP_MM),width:PAGE_WIDTH_MM,height,
  naturalHeight,cropped:false}));
 return {width:PAGE_WIDTH_MM,height:PAGE_HEIGHT_MM,gap:CUT_GAP_MM,cropped:slots.some(slot=>slot.cropped),complete:pair.every(Boolean),slots};
}
function photoGeometry(item,slot,width=1485){
 const w=width,h=Math.max(1,width*slot.height/PAGE_WIDTH_MM);
 const cover=Math.max(w/item.image.naturalWidth,h/item.image.naturalHeight);
 const contain=Math.min(w/item.image.naturalWidth,h/item.image.naturalHeight);
 const scale=contain*item.zoom,iw=item.image.naturalWidth*scale,ih=item.image.naturalHeight*scale;
 return {w,h,iw,ih,autoZoom:1,x:(w-iw)/2+item.x*Math.abs(iw-w)/2,y:(h-ih)/2+item.y*Math.abs(ih-h)/2};
}
const api={layoutPair,photoGeometry,PAGE_WIDTH_MM,PAGE_HEIGHT_MM,CUT_GAP_MM};
if(typeof module==='object'&&module.exports)module.exports=api;else root.PanoramaA4=api;
})(typeof globalThis==='undefined'?this:globalThis);
